"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: center;\n  width: 20%;\n  min-height: 56px;\n  border-right: 1px solid rgba(54, 63, 85, 0.12);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  background-color: ", ";\n\n  &:last-of-type {\n    border-right: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 13px;\n  margin-top: 10px;\n  line-height: 11px;\n  text-align: center;\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding-right: ", ";\n  padding-left: ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin-right: 10px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject());
var StyledIcon = (0, _styledComponents["default"])(_Icon["default"])(_templateObject2(), function (props) {
  return props.paddingRight;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.hover ? 'cursor: pointer;' : '';
}, function (props) {
  return props.highlighted ? 'color: white;' : 'color: #363F55;';
});

var StyledIconLabel = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.highlighted ? 'color: white;' : 'color: #363F55;';
});

var StyledIconWrapper = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.highlighted ? '#363F55;' : 'transparent';
});

var ActionButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ActionButton, _Component);

  var _super = _createSuper(ActionButton);

  function ActionButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, ActionButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.goAction = function () {
      if (_this.props.replaceHistory) {
        _this.context.history.replace(_this.props.to);
      } else {
        _this.context.history.push(_this.props.to);
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(ActionButton, [{
    key: "render",
    value: function render() {
      if (this.props.showAsIcon) {
        return /*#__PURE__*/_react["default"].createElement(StyledIconWrapper, {
          onClick: this.goAction,
          highlighted: this.props.highlighted
        }, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
          icon: this.props.icon,
          highlighted: this.props.highlighted
        }), /*#__PURE__*/_react["default"].createElement(StyledIconLabel, {
          highlighted: this.props.highlighted
        }, this.props.label));
      }

      var color = this.props.secondary ? 'secondary' : 'primary';
      return /*#__PURE__*/_react["default"].createElement(StyledButton, {
        variant: this.props.highlighted ? 'contained' : 'text',
        color: color,
        onClick: this.goAction
      }, this.props.label);
    }
  }]);
  return ActionButton;
}(_react.Component);

ActionButton.contextType = _wrapperContext["default"];
ActionButton.propTypes = {
  label: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string.isRequired,
  showAsIcon: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  replaceHistory: _propTypes["default"].bool,
  highlighted: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool
};
ActionButton.defaultProps = {
  secondary: false
};
var _default = ActionButton;
exports["default"] = _default;